var exports = {
  "y": "AuthLegalLinks.module__links___M1Jub2",
  "n": "AuthLegalLinks.module__link___M1Jub2",
};

module.exports = exports;
